import moment from "moment";

moment.defaultFormat = "DD-MM-YYYY";
